import fakedb from "../fakedb.json";
import moment from "moment";
/**
 * Created by Federico Brocco on 13/05/2022.
 *
 * @format
 */

/**
 * Recupera la lista degli appuntamenti
 * @param {string} idCategory - ID della categoria di appuntamenti
 * @param {string} month - Mese degli appuntamenti
 * @param {string} day - Giorno degli appuntamenti
 * @returns {Promise<Array>} Promise che risolve con un array di appuntamenti
 */
let listAppointments = function (idCategory, month, day) {
    return new Promise(function (resolve, reject) {

        const hash = localStorage.getItem('hash');

        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.appointments, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API appointments', responseJson);
                resolve(responseJson.appointments);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });


    });
};

/**
 * Recupera gli slot disponibili per gli appuntamenti
 * @param {string} idCategory - ID della categoria
 * @param {string} month - Mese di riferimento
 * @param {string} [day] - Giorno specifico (opzionale)
 * @param {string} [type] - Tipo di appuntamento ('presenza' o 'videocall')
 * @returns {Promise<Array>} Promise che risolve con gli slot disponibili
 */
let listSlots = function (idCategory, month, day, type = 'presenza') {
    return new Promise(function (resolve, reject) {

        const hash = localStorage.getItem('hash');

        if (hash === null) {
            reject("NO_AUTH");
            return;
        }
        const baseRoute = type === 'videocall' ? window.route.availability_video : window.route.availability;
        const link = baseRoute + "?id_category=" + idCategory + "&month=" + month + ((typeof day !== "undefined") ? "&day=" + day : '')

        console.log(link)
        fetch(link, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API availability', responseJson);
                resolve(responseJson.availability);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });


    });
};

/**
 * Prenota uno slot disponibile
 * @param {string} availability_id - ID dello slot da prenotare
 * @param {string} [type] - Tipo di appuntamento ('presenza' o 'videocall')
 * @returns {Promise<Object>} Promise che risolve con i dettagli della prenotazione
 */
let bookingSlot = function (availability_id, type = 'presenza') {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        const baseRoute = type === 'videocall' ? window.route.booking_video : window.route.booking;
        const link = baseRoute + "?availability_id=" + availability_id;

        fetch(link, {
            headers: {'x-access-token': hash},
            method: 'POST'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API bookingSlot', responseJson);
                if (typeof responseJson.availability.availability_id !== "undefined")
                    resolve(responseJson.availability);

                reject()
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};



const AppointmentsAPI = {
    listSlots: listSlots,
    bookingSlot: bookingSlot,
    listAppointments: listAppointments
};

export default AppointmentsAPI;
